import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./AboutGarudaSena.css";
import garudaImg from "../Images/helpto.webp";

const AboutGarudaSena = () => {
  const cards = [
    {
      title: "Eligibility & Values",
      desc: "Open to all aged 18–60 who are fit and dedicated to serving devotees with discipline, dignity, and devotion.",
    },
   {
  title: "Membership Donation",
  desc: "Membership donation ₹1008/- (non-refundable) for charitable and spiritual activities under SASCCT.",
},


      {
      title: "Volunteer Service",
      desc: "Assist divyangjan devotees, support divyangjan programs, participate in food donation, blood donation, medical camps etc.",
    },

   
 
  
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleCard = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="about-garudasena">
      <div className="garuda-container">


        <div className="garuda-layout">
          {/* Right content */}
          <div className="garuda-content">
                    <h2>About Garuda Sena Volunteers</h2>
            <div className="garuda-grid garuda-content">
              {cards.map((c, index) => (
                <div
                  key={c.title}
                  className={`garuda-card ${activeIndex === index ? "active" : ""}`}
                  onClick={() => toggleCard(index)}
                >
                  <div className="card-header">
                    <h3>{c.title}</h3>
                    <span className="icon">
                      {activeIndex === index ? "−" : "+"}
                    </span>
                  </div>
                  <div className="card-body">
                    <p>{c.desc}</p>
                  </div>
                </div>
              ))}
                  <div className="garuda-cta">
              <Link to="/garuda-sena-details" className="cta-btn">
                View Full Details →
              </Link>
            </div>
            </div>

        
          </div>

          {/* Left image */}
          <div className="garuda-image">
            <img src={garudaImg} alt="Garuda Sena Volunteers" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutGarudaSena;
